module.exports = __webpack_public_path__ + "static/img/cybercrime_5.cbdff003.png";